import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import { formatDate } from "../../../helpers/formatDate";
import { getSlug, } from "../../../config/routes/guards/slug";
import { Table } from "react-bootstrap";
import { FormScorePokjaComp } from ".."
import Modal from "react-bootstrap/Modal";

Chart.register(...registerables);

const ChartOnePokja = () => {
  const [missingDocument, setMissingDocument] = useState([]);
  const [missingInstruments, setMissingInstruments] = useState([]);
  const [listAkreditasi, setlistAkreditasi] = useState([]);
  const [persentasePokja, setpersentasePokja] = useState([]);
  const [singkatan, setsingkatan] = useState([]);
  const [idKegiatanAkreditasi, setidKegiatanAkreditasi] = useState("");
  const [idBab, setIdBab] = useState("");
  const [idElement, setIdElement] = useState("");
  const [role, setRole] = useState("");
  const [idUser, setidUser] = useState("");
  const [instrument, setInstrument] = useState("");

  const [showFormScorePokja, setshowFormScorePokja] = useState(false);

  const handleAfterSubmitSelfAssessment = () => {
    handleChangePeriodeSurvei(idKegiatanAkreditasi)
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // setidUser(data.data.id);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err?.response?.data);
      MySwal.fire({
        icon: 'info',
        title: 'Oops, Error!',
        text: `${err?.response?.data?.message}`,
      });
    }
  };

  const handleChangePeriodeSurvei = async (id) => {
    setidKegiatanAkreditasi(id);
    try {
      fetchMissingInstruments(id)
      fetchMissingDocument(id)
      const options = {
        url: `/skor/skoring-bar-chart/${id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);

      setsingkatan([]);
      data.capaian.map((d) =>
        setsingkatan((singkatan) => [...singkatan, d.singkatan])
      );

      setpersentasePokja([]);
      data.capaian.map((d) =>
        setpersentasePokja((persentasePokja) => [
          ...persentasePokja,
          d.percentage,
        ])
      );
    } catch (err) {
      console.log(err);
    }
  };

  const fetchSurvei = async () => {
    try {
      const options = {
        url: `/accreditations/list`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setlistAkreditasi(data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchMissingInstruments = async (idKegiatanAkreditasi) => {
    try {
      // console.log(idKegiatanAkreditasi)
      const options = {
        url: `/skor/pending-instruments/${idKegiatanAkreditasi}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);

      setMissingInstruments(data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchMissingDocument = async (idKegiatanAkreditasi) => {
    try {
      // console.log(idKegiatanAkreditasi)
      const options = {
        url: `/skor/missing-doc/${idKegiatanAkreditasi}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);

      setMissingDocument(data);
    } catch (err) {
      console.log(err);
    }
  };


  useEffect(() => {
    fetchSurvei();
    fetchOneUser()
  }, []);

  const data = {
    labels: singkatan,
    datasets: [
      {
        label: "Capaian Pengisian Penilaian Mandiri (%) ",
        data: persentasePokja,
        backgroundColor: [
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
          "rgba(32, 80, 210, 1)",
        ],
        borderColor: [
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
          "rgba(255, 255, 254, 1)",
        ],
        borderWidth: 1,
      },
    ],

  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  const handleShowSelfAssessment = (instrument) => {
    setshowFormScorePokja(true)
    setIdBab(instrument?.elements_accreditation?.chapters_accreditation?.id)
    setIdElement(instrument?.id)
    setInstrument(instrument)
  }

  // console.log(persentasePokja)

  return (
    <>
      <div className="col-lg-4 col-12 mb-5">
        <label className="form-label">Periode Survei</label>
        <select
          className="form-select"
          value={idKegiatanAkreditasi}
          onChange={(e) => handleChangePeriodeSurvei(e.target.value)}
        >
          <option>- Pilih -</option>
          {listAkreditasi.map((accreditation) => (
            <option key={accreditation.id} value={accreditation.id}>
              {formatDate(accreditation.TglMulai)} S/D{" "}
              {formatDate(accreditation.TglBerakhir)}
            </option>
          ))}
        </select>
      </div>
      {
        idKegiatanAkreditasi ?
          <>
            <div className="row" style={{ marginBottom: '35px' }}>
              <div className="col-12 mb-3">
                <h2 style={{ marginTop: '15px' }}>Grafik 1 : Capaian Pengisian Self Assessment</h2>
                <h6 style={{ marginTop: '15px' }} className="text-info mb-3">Grafik ini menunjukan progress pengisian Self Assessment per masing-masing Bab. <br /> Jika angka sudah mencapai 100% berarti semua EP di Bab tersebut sudah berhasil ternilai.</h6>
                <hr></hr>
                <Bar data={data} options={options} />
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <h2 style={{ marginTop: '15px' }}>Table 1 : Elemen Penilaian belum Self Assessment</h2>
                <hr></hr>
                <Table striped bordered hover>
                  <thead className="bg-primary border-1 text-center text-white">
                    <tr>
                      <th>
                        <b>Elemen Penilaian</b>
                      </th>
                      <th>
                        <b>Deskripsi</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="border-1">
                    {
                      missingInstruments.map((instrument, idx) => (
                        <tr key={idx}>
                          <td
                            className="text-center"
                            style={{
                              color: "blue",
                              textDecoration: "underline",
                              cursor: "pointer"
                            }}
                            // onClick={() => handleOpenNewTab(`/chapter/${idKegiatanAkreditasi}/${instrument?.elements_accreditation?.chapters_accreditation?.IdAkreditasi}`)}
                            onClick={() => handleShowSelfAssessment(instrument)}
                          >
                            {instrument?.elements_accreditation?.Nomor}
                          </td>

                          <td>
                            <b>{instrument?.Abjad}.{" "}</b>
                            {instrument?.Deskripsi}
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <h2 style={{ marginTop: '15px' }}>Table 2 : Elemen Penilaian belum ada Dokumen Dukung</h2>
                <hr></hr>
                <Table striped bordered hover>
                  <thead className="bg-primary border-1 text-center text-white">
                    <tr>
                      <th>
                        <b>Elemen Penilaian</b>
                      </th>
                      <th>
                        <b>Deskripsi</b>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="border-1">
                    {
                      missingDocument.map((doc, idx) => (
                        <tr key={idx}>
                          <td
                            className="text-center"
                          >
                            {doc?.variables_accreditation?.elements_accreditation?.Nomor}
                          </td>

                          <td>
                            <b>{doc?.variables_accreditation?.Abjad}.{" "}</b>
                            {doc?.variables_accreditation?.Deskripsi}
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </div>
            </div>


            <Modal
              show={showFormScorePokja}
              onHide={() => setshowFormScorePokja(false)}
              backdrop="static"
              keyboard={false}
              size="md"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  Tambah Penilaian Mandiri{" "}
                  <span className="text-info">
                    {instrument?.elements_accreditation?.Nomor}, EP:{instrument.Abjad}
                  </span>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <FormScorePokjaComp
                  IdKegiatanAkreditasi={idKegiatanAkreditasi}
                  IdBab={idBab}
                  IdVariable={idElement}
                  IdUser={idUser}
                  fetch={handleAfterSubmitSelfAssessment}
                  close={() => setshowFormScorePokja(false)}
                />
              </Modal.Body>
            </Modal>
          </>
          :
          ""
      }

    </>
  );
};

export default ChartOnePokja;
